import React from "react";
import loadingSVG from "../assets/svg/LoadingSpinner.svg";

interface Props {
  isLoading: boolean;
  defaultText: string;
}

const defaultProps = {
  isLoading: false,
};

const LoadingStatus: React.FC<Props> = (props): React.ReactElement<any> => {
  const { isLoading = defaultProps.isLoading, defaultText } = props;
  return isLoading ? (
    <div className="flex items-center justify-center">
      <img src={loadingSVG} alt="loader" className="mr-1 h-5 w-5" />
      <p className="text-sm">Processing…</p>
    </div>
  ) : (
    <p className={`text-sm`}>{defaultText}</p>
  );
};

export default LoadingStatus;
